/** Where a screenshot reading has got to. */
export enum EvidenceJobStatus {
  /** Accepted, still being read. The client polls. */
  Pending = "pending",
  /** Read. The disposition says whether it may prefill the form. */
  Complete = "complete",
  /** Reading broke. The participant types the ride in instead. */
  Failed = "failed",
}

/** Whether a reading may prefill the form, needs confirming, or is refused. */
export enum EvidenceDisposition {
  Ready = "ready",
  Confirm = "confirm",
  Reject = "reject",
}

/** What the tracker showed before we converted it. */
export interface EvidenceConversion {
  value: number;
  unit: "km";
}

/** The part of the reading the form prefills from. */
export interface EvidenceExtraction {
  /** ISO yyyy-mm-dd as printed on screen, or null when none was legible. */
  rideDate: string | null;
}

/**
 * One screenshot reading, as the participant's browser sees it.
 *
 * Carries the reading, never the picture: the stored screenshot is an
 * organizer's reference, and the form only needs what was read off it.
 */
export interface EvidenceJob {
  id: string;
  status: EvidenceJobStatus;
  disposition?: EvidenceDisposition;
  /** Miles after any unit conversion. */
  miles?: number;
  /** Set when the tracker showed kilometres, so the page can say so. */
  convertedFrom?: EvidenceConversion;
  /** The tracker we recognised, when we recognised one. */
  sourceLabel?: string;
  /** Plain-language notes for the participant. Our words, never model output. */
  notes?: string[];
  /** Set when extraction itself broke, as opposed to producing a refusal. */
  failureMessage?: string;
  extracted?: EvidenceExtraction;
}

/** What the upload endpoint answers with before any reading exists. */
export interface EvidenceUploadResponse {
  jobId: string;
  status: EvidenceJobStatus;
}
